import React, { ElementType, forwardRef, MutableRefObject } from 'react';
import classNames from 'classnames';
import styles from './ListItem.module.scss';

type ListItemWithRefProps = React.HTMLProps<any> & {
  selectable?: boolean;
  selected?: boolean;
  isInList?: boolean;
};

export type ListItemProps<AsTypeProps> = Omit<React.HTMLProps<any>, 'as'> &
  AsTypeProps & {
    as?: ElementType;
    selectable?: boolean;
    selected?: boolean;
    isInList?: boolean;
  };

function Title({ className = null, children = null, ...props }) {
  className = classNames(className, styles.title, 'text-contact');

  return (
    <Content className={className} {...props}>
      {children}
    </Content>
  );
}

function Content({ className = null, children, fill = false, spaceless = false, ...props }) {
  className = classNames(
    className,
    styles.content,
    fill ? styles.contentFill : null,
    spaceless && styles.spaceless,
  );
  return (
    <span className={className} {...props}>
      {children}
    </span>
  );
}

export default function ListItem<AsTypeProps>({
  as: Component = 'div',
  selectable = false,
  selected = false,
  isInList = false,
  className = null,
  children,
  ...props
}: ListItemProps<AsTypeProps>) {
  className = classNames(
    styles.item,
    className,
    selectable ? styles.selectable : null,
    selected ? styles.selected : null,
    selected ? 'list-item-selected' : null,
    isInList && styles.list,
  );

  return (
    <Component className={className} {...props}>
      {children}
    </Component>
  );
}

export const ListItemWithRef = forwardRef(
  (
    {
      selectable = false,
      selected = false,
      isInList = false,
      className = null,
      children,
      ...props
    }: ListItemWithRefProps,
    ref: MutableRefObject<HTMLDivElement>,
  ) => {
    className = classNames(
      styles.item,
      className,
      selectable ? styles.selectable : null,
      selected ? styles.selected : null,
      selected ? 'list-item-selected' : null,
      isInList && styles.list,
    );

    return (
      <div className={className} {...props} ref={ref}>
        {children}
      </div>
    );
  },
);

ListItem.Title = Title;
ListItem.Content = Content;
